// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-container {
  position: relative;
  min-height: var(--ce-interactable-min-height);
  display: flex;
  align-items: center;
  cursor: pointer;
}

.clickTargetExpander {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  cursor: pointer;
}

.input-container.full-width {
  width: 100%;
}

.input-container.full-width input {
  width: 100%;
}

.input-container input {
  color: var(--ce-black);
  border: 1px solid var(--ce-grey-20);
  border-radius: var(--ce-border-radius-default);
  font-family: var(--ce-font-family-body);
  padding: var(--ce-interactable-padding-default);
}

.input-container input[disabled] {
  background-color: var(--ce-grey-10);
  cursor: not-allowed;
}

.input-container.size-small input {
  font-size: var(--ce-form-small);
  padding: var(--ce-interactable-padding-small);
}
.input-container.size-large input {
  font-size: var(--ce-form-large);
  padding: var(--ce-interactable-padding-large);
}

.has-icon-left input {
  padding-left: calc(var(--ce-base-padding-h) * 2 + 16px);
}
.has-icon-right input {
  padding-right: calc(var(--ce-base-padding-h) * 2 + 16px);
}

.element-left,
.element-right,
.icon-left,
.icon-right {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.icon-left {
  left: var(--ce-base-padding-h);
}

.icon-right {
  right: var(--ce-base-padding-h);
}

.element-left {
  left: 0;
}

.element-right {
  right: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/presentational/Input/Input.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,6CAA6C;EAC7C,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,mCAAmC;EACnC,8CAA8C;EAC9C,uCAAuC;EACvC,+CAA+C;AACjD;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,6CAA6C;AAC/C;AACA;EACE,+BAA+B;EAC/B,6CAA6C;AAC/C;;AAEA;EACE,uDAAuD;AACzD;AACA;EACE,wDAAwD;AAC1D;;AAEA;;;;EAIE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV","sourcesContent":[".input-container {\n  position: relative;\n  min-height: var(--ce-interactable-min-height);\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.clickTargetExpander {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  cursor: pointer;\n}\n\n.input-container.full-width {\n  width: 100%;\n}\n\n.input-container.full-width input {\n  width: 100%;\n}\n\n.input-container input {\n  color: var(--ce-black);\n  border: 1px solid var(--ce-grey-20);\n  border-radius: var(--ce-border-radius-default);\n  font-family: var(--ce-font-family-body);\n  padding: var(--ce-interactable-padding-default);\n}\n\n.input-container input[disabled] {\n  background-color: var(--ce-grey-10);\n  cursor: not-allowed;\n}\n\n.input-container.size-small input {\n  font-size: var(--ce-form-small);\n  padding: var(--ce-interactable-padding-small);\n}\n.input-container.size-large input {\n  font-size: var(--ce-form-large);\n  padding: var(--ce-interactable-padding-large);\n}\n\n.has-icon-left input {\n  padding-left: calc(var(--ce-base-padding-h) * 2 + 16px);\n}\n.has-icon-right input {\n  padding-right: calc(var(--ce-base-padding-h) * 2 + 16px);\n}\n\n.element-left,\n.element-right,\n.icon-left,\n.icon-right {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.icon-left {\n  left: var(--ce-base-padding-h);\n}\n\n.icon-right {\n  right: var(--ce-base-padding-h);\n}\n\n.element-left {\n  left: 0;\n}\n\n.element-right {\n  right: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
